import { render, staticRenderFns } from "./SchoolView.vue?vue&type=template&id=e2fef2e0&"
import script from "./SchoolView.vue?vue&type=script&lang=js&"
export * from "./SchoolView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolView.vue?vue&type=style&index=0&id=e2fef2e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports